import { useCallback } from "react";
import { Toast } from "@covertree/utils";
import { useResendRenewalOfferMutation } from "@covertree/agent-portal-graphql";
import { getErrorMessageFromApolloError } from "@utils/getErrorMessageFromApolloError";

export function useResendRenewalOffer() {
  const [resendRenewalOffer, { loading }] = useResendRenewalOfferMutation();

  const resendRenewalOfferHandler = useCallback(
    async (renewalLocator: string) => {
      try {
        await resendRenewalOffer({
          variables: {
            renewalLocator,
          },
        });

        Toast.showSuccess("Renewal offer sent.");
      } catch (error) {
        Toast.showError(
          getErrorMessageFromApolloError(error) ??
            "Could not send renewal offer. Please try again"
        );
      }
    },
    [resendRenewalOffer]
  );

  return {
    resendRenewalOffer: resendRenewalOfferHandler,
    loading,
  };
}
